var render, staticRenderFns
import script from "./App.vue?vue&type=script&lang=tsx"
export * from "./App.vue?vue&type=script&lang=tsx"
import style0 from "./App.vue?vue&type=style&index=0&id=e3518b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3518b30",
  null
  
)

export default component.exports